import { getCuentasMetasAll, newCargoCuenta } from "../services/serviceUsuarios";

const dataInicial = {
  array: [],
  exito: 0,
  nombre: "0",
  referencia: "0"
};

const GET_PAGO_UNICO_CLEAR_STATE = "GET_PAGO_UNICO_CLEAR_STATE";
const GET_PAGO_UNICO_ALL = "GET_PAGO_UNICO_ALL";
const POST_PAGO_UNICO_NEW = "POST_PAGO_UNICO_NEW";

export default function pagoUnicoReducer(state = dataInicial, action) {
  switch (action.type) {
    case POST_PAGO_UNICO_NEW:
      return { ...state, exito: action.payload.exito, array: action.payload.array }
    case GET_PAGO_UNICO_ALL:
      return { ...state, array: action.payload.array, nombre: action.payload.nombre, referencia: action.payload.referencia };
    case GET_PAGO_UNICO_CLEAR_STATE:
      return {
        ...state,
        array: action.payload.array,
        exito: action.payload.exito,
      };
    default:
      return state;
  }
}

export const obtenerClientesAction = (nombre, referencia) => async (dispatch) =>{
  return await getCuentasMetasAll({nombre, referencia}).then((Response) =>{
    dispatch({
      type: GET_PAGO_UNICO_ALL,
      payload: {
        array: Response,
        nombre,
        referencia
      },
    });
  }).catch((Error) =>{
    return [];
  })
}

export const newPagoUnicoAction = (payload) => async (dispatch, getState) =>{
  const nombre = getState().pagoUnico.nombre
  const referencia = getState().pagoUnico.referencia
  const newUser = await newCargoCuenta({payload})
  const newArray = await getCuentasMetasAll({nombre, referencia})
  dispatch({
    type: POST_PAGO_UNICO_NEW,
    payload: {
      exito: 1,
      array: newArray,
    },
  });
  return newUser;
}

export const clearUsuarioState = () => async (dispatch) => {
  dispatch({
    type: GET_PAGO_UNICO_CLEAR_STATE,
    payload: dataInicial,
  });
};
